// 统一识别浏览器与 Cordova Android，避免标题栏、设置页各自判断产生差异。
export function getRuntimePlatform () {
  const cordova = window.cordova
  const platformId = String((cordova && cordova.platformId) || window.cordova_platformId || '').toLowerCase()
  const userAgent = String(navigator.userAgent || '')
  const isAndroid = platformId === 'android' || /Android/i.test(userAgent)
  const isNativeProtocol = ['file:', 'content:', 'app:'].includes(window.location.protocol)
  const isCordovaAndroidHost = window.__FLICUBE_NATIVE_ANDROID__ === true || (
    isAndroid && ['localhost', '127.0.0.1'].includes(window.location.hostname)
  )
  const isCordova = Boolean(cordova || window.cordova_platformId || isNativeProtocol || isCordovaAndroidHost)
  const isCordovaAndroid = isCordova && isAndroid

  return {
    isWebClient: !isCordova,
    isCordovaAndroid
  }
}
